// Dependencies
import { FC, useContext } from "react";

// Components
import { Typography } from "@mui/material";
import { TransactionContext } from "~/pages/Transactions";
import TransactionItem from "../TransactionItem";

// utils
import {
  currencyFormat,
  getDateFromTimeString,
  convertCurrencyStringToNumber,
} from "~/utils";

// Styles
import {
  StyledDate,
  StyledWrapper,
  StyledWeekDate,
  StyledFullDate,
  StyledDayWrapper,
} from "./DayTransactions.styled";
import TransactionAmount from "../TransactionAmount";

interface DayTransactionsProps {
  dateString: string;
  transactionData: any[];
  walletId: string;
  walletCurrency: string;
}

const DayTransactions: FC<DayTransactionsProps> = ({
  dateString,
  transactionData,
  walletId,
  walletCurrency,
}) => {
  const { handleShowDetail } = useContext(TransactionContext);

  const { date, weekDate, monthYear } = getDateFromTimeString(dateString);

  const dayTotal = transactionData?.reduce((accumulator, current) => {
    const currentAmount = convertCurrencyStringToNumber(current?.amount);
    if (currentAmount) {
      return currentAmount * current?.sign + accumulator;
    }
    return 0;
  }, 0);

  return (
    <StyledWrapper>
      <StyledDayWrapper>
        <StyledFullDate>
          <StyledDate>{date}</StyledDate>
          <StyledWeekDate>
            <Typography variant={"h3"}>{weekDate}</Typography>
            <Typography variant={"h4"}>{monthYear}</Typography>
          </StyledWeekDate>
        </StyledFullDate>
        <TransactionAmount sign={dayTotal < 0 ? -1 : 1} variant={"h2"}>
          {currencyFormat(dayTotal, walletCurrency)}
        </TransactionAmount>
      </StyledDayWrapper>
      {transactionData?.map(
        (transaction: {
          categoryName: string;
          categoryID: string;
          note: string;
          username: string;
          amount: string;
          sign: -1 | 1;
          transactionID: string;
        }) => (
          <TransactionItem
            key={transaction?.transactionID}
            onClick={() =>
              handleShowDetail(
                transaction?.transactionID,
                walletCurrency,
                walletId
              )
            }
            {...transaction}
            walletCurrency={walletCurrency}
          />
        )
      )}
    </StyledWrapper>
  );
};

export default DayTransactions;
